module.exports = __webpack_public_path__ + "img/Wp_2061.63839b60.png";